import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getWebContents = async (params) => {
	const { data } = await axios.get(`${API}/admin/web_contents`, { params });
	return data;
};

export const getWebContent = async (params) => {
	const { data } = await axios.get(`${API}/admin/web_contents/detail`, {
		params,
	});
	return data;
};

export const saveWebContent = async (params) => {
	const { data } = await axios.post(`${API}/admin/web_contents/save`, params);
	return data;
};
